import React, { FC } from 'react';

const LightModeClose: FC = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="22" height="22" rx="11" fill="white" fillOpacity="0.24" />
    <path
      d="M6.83325 6.83331L15.1666 15.1666"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M15.1667 6.83331L6.83341 15.1666"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export default LightModeClose;
